import { Component, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ShowHideComponent),
  multi: true
};

@Component({
  selector: 'show-hide-password',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
  template: `
    <label for="show-hide-password">{{ 'auth.password' | translate }}</label>
    <div class="input-group">
      <input type="{{type}}" class="form-control" placeholder="{{ 'auth.password' | translate }}" aria-describedby="show-hide-password" [(ngModel)]="value" required>
      <span class="input-group-addon" id="show-hide-password" (click)="toggleShow()" style="cursor: pointer;">
      <i class="fa" [ngClass]="{
        'fa-eye': show,
        'fa-eye-slash': !show
      }"></i>
      </span>
    </div>
  `
})
export class ShowHideComponent {
  private _value: any = '';

  public show: boolean = false;
  public type: string = 'password';

  constructor() {}

  get value(): any {
    return this._value;
  }
  // set the value (emit) to the parent model
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }
  // write the value to the input
  writeValue(value: any) {
    this._value = value;
    this.onChange(value);
  }

  onChange = _ => {};
  onTouched = () => {};
  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  toggleShow() {
    this.show = !this.show;
    this.type = this.show ? 'text' : 'password';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/generic_login/show-hide.component.ts